import React from "react";

import Entities from "../../components/Entities";

function Products() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "products",
        fields: [
          {
            name: "Banner",
            propertyName: "banner",
            filter: true,
            hidden: true,
            filterRoute: "banners",
          },
          {
            name: "Principal",
            propertyName: "manufacturer",
            isObject: true,
            search: true,
            filter: true,
            filterRoute: "manufacturers",
          },
          {
            name: "Status",
            propertyName: "status",
            filter: true,
            hidden: true,
            filterOptions: [
              { label: "Active", value: "ACTIVE" },
              { label: "Inactive", value: "INACTIVE" },
            ],
          },
          {
            name: "Brand",
            propertyName: "make",
            search: true,
          },
          {
            name: "Description",
            propertyName: "description",
            search: true,
          },
          {
            name: "UPC Code",
            propertyName: "upcCode",
            search: true,
          },
          {
            name: "Size",
            propertyName: ["formatQut", "format"],
          },
          {
            name: "Product Type",
            propertyName: "productType",
            isObject: true,
            filter: true,
            hidden: true,
            filterRoute: "product_types",
          },
          {
            name: "Store Code / Price",
            propertyName: "prices",
            renderCell: (product, i) => {
              const prices = [...(product.prices ?? [])].sort((a, b) =>
                (a.banner?.name ?? "").localeCompare(b.banner?.name ?? "")
              );
              return (
                <td key={i}>
                  <div style={{ maxHeight: 80, overflowY: "auto" }}>
                    {prices.map((p, j) => (
                      <div key={j} style={{ fontSize: "0.78rem" }}>
                        <span className="text-muted">{p.code || "n/a"}</span>
                        {" "}{p.banner?.name}
                        {p.province?.name && (
                          <span className="text-muted"> · {p.province.name}</span>
                        )}
                        {p.retailPrice && <span> — {p.retailPrice}</span>}
                      </div>
                    ))}
                  </div>
                </td>
              );
            },
          },
        ],
      }}
    />
  );
}

export default Products;
